export function customizeFilter(items, itemToSearch, columneNotFilter) {
  let recivedItems = [];
  let columne = [];
  let searchItem = itemToSearch.trim();
  recivedItems = items;

  //columneNotFilter object attribute in which we dont want search for item

  columne = columneNotFilter ? columneNotFilter : [];
  const filterItems = recivedItems.filter((item) => {
    const keys1 = Object.keys(item);
    for (let i = 0; i < keys1.length; i++) {
      if (
        item[keys1[i]] !== null &&
        item[keys1[i]] !== "" &&
        !columne.includes(keys1[i])
      ) {
        const items = item[keys1[i]].toString();
        if (items === "false" && "no".includes(searchItem.toLowerCase())) {
          return item;
        } else if (
          items === "true" &&
          "yes".includes(searchItem.toLowerCase())
        ) {
          return item;
        } else if (items.toLowerCase().includes(searchItem.toLowerCase())) {
          return item;
        }
      }
    }
  });
  return filterItems;
}

export function mainGridFilter(itemList, itemtoSearch, columneNotFilter) {
  let recivedItems = [];
  let columne = [];
  const searchItem = itemtoSearch.trim();

  itemList.map((item, i) => {
    let status = true;
    item.map((elem, j) => {
      if (
        j !== columneNotFilter &&
        elem.value !== null &&
        elem.value !== undefined
      ) {
        if (
          elem.value.toLowerCase().includes(searchItem.toLowerCase()) &&
          status
        ) {
          columne.push(item);
          status = false;
          return;
        }
      }
    });
  });
  return columne;
}
